import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "upload-file-button primary inverse" }

import ChatUpload from "~/chat/vue/widget/form/ChatUpload.vue";
import ChatFormInlineSvgIcon from "~/chat/vue/widget/form/fields/ChatFormInlineSvgIcon.vue";
import {useChatFormInput, useChatFormInputProps} from "~/chat/vue/widget/form/fields/useChatFormInput";
import {computed} from "vue";
import {__} from "~/ts/library/Translate";
import {IFileShareField} from "~/cabinet/vue/interface/form/elements/Interfaces";


const __default__ = {
    name: "ChatFileInput"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    ...useChatFormInputProps<IFileShareField>()
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

let props = __props;

let emits = __emit;

let {exposedObject, placeholder} = useChatFormInput(props);

__expose(exposedObject);

let filesArray = computed(() => {
    return props.modelValue && props.modelValue.length ? props.modelValue.split("\n") : [];
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
        'like-input': true,
        error: _ctx.error
    })
  }, [
    _createElementVNode("div", null, [
      _createVNode(ChatFormInlineSvgIcon, { field: _ctx.field }, null, 8, ["field"]),
      _createTextVNode(" " + _toDisplayString(_unref(placeholder)), 1)
    ]),
    _createVNode(ChatUpload, {
      class: "mt-2",
      "model-value": _unref(filesArray),
      accept: _unref(props).field.accept,
      "show-accept-files": "",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('update:modelValue', $event ? $event.join('\n') : null)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", _hoisted_1, _toDisplayString(_unref(__)('UPLOAD_FILE')), 1)
      ]),
      _: 1
    }, 8, ["model-value", "accept"])
  ], 2))
}
}

})